import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';
import { Vehicle } from '@sm360/widget-commons-vehicle';

import 'vdp-used/components/VehicleFeatures/VehicleFeatures.scss';

class VehicleFeatures extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: false,
            iconClass: '',
        };

        this.mapFeatures = this.mapFeatures.bind(this);
        this.showMore = this.showMore.bind(this);
    }

    showMore() {
        this.setState({
            collapse: !this.state.collapse,
            iconClass: this.state.iconClass !== '' ? '' : 'reverse',
        });
    }

    mapFeatures(featuresList) {
        return featuresList?.map((feature, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className="showroom-vdp-used-options-item" key={`${feature}-${index}`}>
                <span>{feature}</span>
            </li>
        ));
    }

    render() {
        const options = this.mapFeatures(this.props.vehicle?.options);
        const iconDirection = ['icon-chevron-thin-down', this.state.iconClass];

        return (
            <div className="showroom-vdp-used-options" onClick={this.showMore}>
                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                    <h2 className="vdp-information__title">{LocaleService.t('VEHICLE_FEATURES.FEATURES')}</h2>
                    <ul className="showroom-vdp-used-options-list clearfix">{options}</ul>
                </MediaQuery>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <h2 className="sr-subtitle-1 is-centered">{LocaleService.t('VEHICLE_FEATURES.FEATURES')}</h2>
                    <icon className={iconDirection.join(' ')}>&nbsp;</icon>
                    <ReactCollapse isOpened={this.state.collapse}>
                        <ul className="showroom-vdp-used-options-list clearfix">{options}</ul>
                    </ReactCollapse>
                </MediaQuery>
            </div>
        );
    }
}

VehicleFeatures.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
};

VehicleFeatures.displayName = 'VehicleFeatures';

export default VehicleFeatures;
